import * as React from 'react'

import { type UserTraits } from '@segment/analytics-next'

import { type SegmentAnalyticsMetadata, type User } from '@webapp/models'
import { injectSegmentDeprecated } from './utils'

export interface IGlobalAnalyticsProps {
  user: User
  segmentAnalyticsMetadata: SegmentAnalyticsMetadata
}

export const GlobalAnalyticsDeprecated: React.FC<IGlobalAnalyticsProps> =
  React.memo(({ user, segmentAnalyticsMetadata }: IGlobalAnalyticsProps) => {
    if (!user) return null

    injectSegmentDeprecated()

    const analytics = window?.analytics

    React.useEffect(() => {
      analytics?.identify(
        segmentAnalyticsMetadata.user.id,
        segmentAnalyticsMetadata.user.metadata as UserTraits
      )

      analytics?.group(
        segmentAnalyticsMetadata.group.id,
        segmentAnalyticsMetadata.group.metadata
      )
    }, [])

    return null
  })

GlobalAnalyticsDeprecated.displayName = 'GlobalAnalyticsDeprecated'
